import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import type { User } from 'firebase/auth';
import * as Sentry from '@sentry/react';
import { auth } from '../firebase/config';

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
      // Tag Sentry events with the signed-in user's uid so crash reports
      // are attributable — mirrors the mobile app's setSentryUser flow.
      // Cleared on sign-out to prevent leaking identity across accounts.
      Sentry.setUser(u ? { id: u.uid } : null);
    });
    return unsubscribe;
  }, []);

  return { user, uid: user?.uid ?? null, loading };
}
